import { createElement } from 'react'
import { Loader } from 'App/Components'
import { configure as configureLazyPage } from '@monorepo/deprecated/core/hoc/lazyPage'
// import { withLayout } from 'app/view/Layout'

configureLazyPage({ delay: 200, pageLoader: createElement(Loader) })
